import _Vue from "vue";
import { RouteConfig, Route, NavigationGuardNext } from 'vue-router';

import GlobalWorkspaceService from './service';
import GlobalWorkspaceStoreModule from './module';
import WorkspaceWrapper from './WorkspaceWrapper.vue';
import type { GlobalWorkspaceOptions } from './options';

interface GlobalWorkspace {
	options: GlobalWorkspaceOptions;
	home: string;
	isGlobal: boolean;
	setToGlobal(): void;
	setToNonGlobal(): void;
	boot(options: GlobalWorkspaceOptions): void;
}

const globalWorkspace = new GlobalWorkspaceService();

function GlobalWorkspacePlugin(Vue: typeof _Vue, options: GlobalWorkspaceOptions): void {
	globalWorkspace.boot(options);
	Object.defineProperty(Vue.prototype, '$globalWorkspace', {
		get () { return globalWorkspace; }
	});
}

const setToGlobalBeforeEnter = (to: Route, from: Route, next: NavigationGuardNext) => {
	if (globalWorkspace) globalWorkspace.setToGlobal();
	next();
};

const setToNonGlobalBeforeEnter = (to: Route, from: Route, next: NavigationGuardNext) => {
	if (globalWorkspace) globalWorkspace.setToNonGlobal();
	next();
};

const GlobalWorkspaceRoutes = function(children: RouteConfig[]) {
	return {
		path: '/global',
		component: WorkspaceWrapper,
		children: children,
		beforeEnter: setToGlobalBeforeEnter
	};
};

const NonGlobalWorkspaceRoutes = function(children: RouteConfig[]) {
	return {
		path: '/',
		component: WorkspaceWrapper,
		children: children,
		beforeEnter: setToNonGlobalBeforeEnter
	};
};

export {
	GlobalWorkspacePlugin,		// Pass to Vue.use

	/* Helpers */
	GlobalWorkspaceRoutes,		// Register Global Workspace routes
	NonGlobalWorkspaceRoutes,	// Register NonGlobal Workspace (w/ no URI segment)
	setToGlobalBeforeEnter,		// BeforeEnter handler to setToGlobal
	setToNonGlobalBeforeEnter,	// BeforeEnter handler to setToNonGlobal

	/* Types */
	GlobalWorkspace,			// Service Interface
	GlobalWorkspaceOptions,		// Options (see `./options`)

	/* Utils */ 
	GlobalWorkspaceStoreModule,
	GlobalWorkspaceService,

	/* Service Instance */
	globalWorkspace				// Service Instance, also available via $globalWorkspace
};